var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_c('Header'),_c('div',{staticClass:"container main"},[_c('div',{ref:"productOne",staticClass:"productOne"},[_c('productHeader',{attrs:{"product":_vm.product,"specs":_vm.specs},on:{"changeSpecs":_vm.changeSpecs,"changeNumber":_vm.changeNumber}})],1),_c('Details',{attrs:{"product":_vm.product}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }